<template>
    <div class="js-main">
        <self-header></self-header>
        <div class="js-middle">
            <self-menu class=""></self-menu>
            <div class="content-box">
                <router-view class=""></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import header from '@/components/header.vue';
import menu from '@/components/menu.vue';

export default {
    data() {
        return {};
    },
    components: {
        'self-header': header,
        'self-menu': menu
    },
    mounted: function() {
        
    }
}
</script>
<style scoped>
</style>